import { Typography } from 'antd';
import React, { FC } from 'react';
import CopyButton from './CopyButton';
import styled, { CSSProperties } from 'styled-components';
import cx from 'classnames';

interface TerminalIdProps {
  id: string;
  withCopy?: boolean;
  style?: CSSProperties;
  className?: string;
}

const TerminalId: FC<TerminalIdProps> = (props) => {
  const { id, withCopy, className, style } = props;
  return (
    <Typography.Text className={cx('text-gray', className)} style={style}>
      {id}
      {withCopy && <CopyButton text={id} isIcon />}
    </Typography.Text>
  );
};

export default styled(TerminalId)`
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #808080;
`;
